import { PdfViewer, usePdfFile } from '@acme/features';
import {
  BreadcrumbItem,
  Field,
  Page,
  Separator,
  formatDateTime,
} from '@acme/foundation';
import { $application, applicationOpened } from '@entities/application';
import { useUnit } from 'effector-react';
import { Button, Card, Checkbox, Label } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const SignDocumentPage = () => {
  const { id, actionId } = useParams();
  const navigate = useNavigate();
  const application = useUnit($application);
  const onApplicationOpened = useUnit(applicationOpened);

  const onSuccessSign = useCallback(() => {
    if (id) {
      onApplicationOpened({ id });
      navigate(`/application/${id}`);
    }
  }, [id, onApplicationOpened, navigate]);

  const {
    loadPdfFile,
    getDocument,
    blob,
    isLoading: isLoadingPdfFile,
    isDocumentLoading,
    error,
    handleSignAction,
  } = usePdfFile({ onSuccessSign });

  const [isChecked, setIsChecked] = useState(false);

  const handleSignClick = () => {
    if (actionId) handleSignAction(actionId);
  };

  const breadcrumbItems: BreadcrumbItem[] = [
    { label: 'Главная', onClick: () => navigate('/dashboard') },
    ...(application
      ? [
          {
            label: application.code ?? 'Заявка',
            onClick: () => navigate(`/application/${application.id}`),
          },
          { label: 'Подписание документа' },
        ]
      : [{ label: 'Заявка не найдена' }]),
  ];

  useEffect(() => {
    if (actionId) getDocument(actionId);
  }, [actionId]);

  return (
    <Page breadcrumbItems={breadcrumbItems}>
      <Card>
        <div className="flex gap-4 justify-between items-center">
          <h2 className="font-semibold text-xl">Подписание документа</h2>
          <Button
            onClick={loadPdfFile}
            color="alternative"
            disabled={isLoadingPdfFile}
          >
            Скачать
          </Button>
        </div>

        <div className="grid grid-cols-4 gap-6">
          <Field label="Номер заявки" value={application?.code} />
          <Field
            label="Дата создания"
            value={formatDateTime(application?.createdAt)}
          />
        </div>

        <Separator className="-mx-6" />

        <div className="mb-6">
          {isDocumentLoading && (
            <div className="flex items-center justify-center p-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
              <span className="ml-2">Загрузка документа...</span>
            </div>
          )}
          {error && (
            <div className="flex items-center justify-center p-8 text-red-500">
              {error}
            </div>
          )}
          {blob && !isDocumentLoading && !error && (
            <PdfViewer file={blob} className="overflow-y-auto" />
          )}
        </div>

        <Separator className="-mx-6" />

        <div className="flex justify-between items-center">
          <Label className="flex gap-2 items-center">
            <Checkbox onChange={(e) => setIsChecked(e.target.checked)} />
            <span>Я ознакомился и согласен с условиями документа</span>
          </Label>
          <Button
            onClick={handleSignClick}
            color="primary"
            disabled={!isChecked}
          >
            Подписать КЭП
          </Button>
        </div>
      </Card>
    </Page>
  );
};
